import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import zh from "./components/locals/chinese.json";
import en from "./components/locals/english.json";
import fr from "./components/locals/french.json";
import ja from "./components/locals/japanese.json";
import ko from "./components/locals/korean.json";
import ru from "./components/locals/russian.json";
import es from "./components/locals/spanish.json";

export const translationUtil = (parentResources) => {
  const resources = {
    en: {
      translation: Object.assign(en, parentResources?.en),
    },
    es: {
      translation: Object.assign(es, parentResources?.es),
    },
    fr: {
      translation: Object.assign(fr, parentResources?.fr),
    },
    zh: {
      translation: Object.assign(zh, parentResources?.zh),
    },
    ja: {
      translation: Object.assign(ja, parentResources?.ja),
    },
    ko: {
      translation: Object.assign(ko, parentResources?.ko),
    },
    ru: {
      translation: Object.assign(ru, parentResources?.ru),
    },
  };

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      detection: {
        order: ["navigator"],
        lookupQuerystring: "lng",
        whitelist: ["en", "es", "fr", "zh", "ja", "ko", "ru"],
      },
      fallbackLng: "en",
      resources,
      compatibilityJSON: "v3",
      interpolation: {
        escapeValue: false,
      },
    });
  return i18n;
};
